import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSend"><Path d="M20.9021 5.2869C21.3196 3.9415 20.0574 2.6793 18.712 3.09684L2.18837 8.22487C0.498062 8.74945 0.565609 11.1647 2.28263 11.594L10.235 13.5821C10.3245 13.6045 10.3945 13.6744 10.4169 13.764L12.4049 21.7163C12.8342 23.4333 15.2495 23.5009 15.7741 21.8106L20.9021 5.2869Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSend;
